import LoadingAnimation from '@/components/LoadingAnimation/LoadingAnimation'
import ConfigureDeviceStepBody from '../components/ConfigureDeviceStepBody'
import ConfigureDeviceCard from '../components/ConfigureDeviceCard'
import ConfigureSettingRow from '../components/ConfigureSettingRow'
import ProgramPrescribedAlert from '../components/ProgramPrescribedAlert'
import useConfigureChargerViewModel from './ConfigureCharger.viewmodel'
import { logException } from '@/logging/sentry'
import { Icon } from '@/components'

export default function ConfigureCharger() {
  const {
    isLoadingOrIdle,
    displayName,
    goalsValueText,
    hasPrescribedGoal,
    prescribedGoals,
    settingPaths,
  } = useConfigureChargerViewModel()

  if (isLoadingOrIdle) {
    return (
      <div className="flex justify-center items-center h-full">
        <LoadingAnimation type="falling" />
      </div>
    )
  }

  // Defensive: shared `usePrescribedChargers` already filters out chargers
  // without a prescribed goal, so reaching this branch indicates a bug —
  // render nothing rather than crash.
  if (!hasPrescribedGoal) {
    logException(
      new Error(
        'ConfigureCharger rendered for a charger with no prescribed goal',
      ),
    )
    return null
  }

  const illustration = (
    <div className="flex p-1.5 bg-themed-purple-100 rounded-lg">
      <Icon name="Zap" size={32} color="base-purple-500" />
    </div>
  )

  return (
    <ConfigureDeviceStepBody>
      <ConfigureDeviceCard
        title={displayName}
        subtitle="Charger"
        illustration={illustration}
      >
        {prescribedGoals.map((goal) => (
          <ProgramPrescribedAlert
            key={goal.label}
            settingDisplayName={goal.label}
            requiredDirection={goal.requiredDirection}
          />
        ))}

        <ConfigureSettingRow
          iconName="Target"
          title="Charging Preferences"
          description="Set charging goals with Optiwatt. Tell us what matters most to you"
          destinationPath={settingPaths.chargingPreferences}
        >
          {goalsValueText}
        </ConfigureSettingRow>
      </ConfigureDeviceCard>
    </ConfigureDeviceStepBody>
  )
}
